import { render, staticRenderFns } from "./SurplusForm.vue?vue&type=template&id=356593b1&scoped=true&"
import script from "./SurplusForm.vue?vue&type=script&lang=js&"
export * from "./SurplusForm.vue?vue&type=script&lang=js&"
import style0 from "./SurplusForm.vue?vue&type=style&index=0&id=356593b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356593b1",
  null
  
)

export default component.exports